<mat-dialog-content class="new-address-dialog">
  <!-- =====================================================
         HEADER
         ===================================================== -->
  <header class="new-address-header">
    <div class="new-address-heading">
      <span class="new-address-eyebrow">
        ENVÍO A DOMICILIO
      </span>
      <h2>
        Verificación de Dirección
      </h2>
    </div>
    <button class="new-address-close" type="button" aria-label="Cerrar" (click)="close()">
      <mat-icon>
        close
      </mat-icon>
    </button>
  </header>
  <!-- =====================================================
         BODY
         ===================================================== -->
  <div class="new-address-body">
    <p class="new-address-description">
      Completa los datos y marca en el mapa la ubicación exacta
      de tu domicilio.
    </p>
    <!-- =================================================
             UBICACIÓN DE REFERENCIA
             ================================================= -->
    <div class="reference-location" *ngIf="isReferenceLocation">
      <mat-icon>
        location_on
      </mat-icon>
      <span>
        Este pin es la ubicación que elegiste para tu envío.
        Úsalo como referencia o arrástralo si no coincide
        con tu domicilio.
      </span>
    </div>
    <!-- =================================================
             FORMULARIO
             ================================================= -->
    <form [formGroup]="addressForm" (ngSubmit)="saveAddress()" novalidate>
      <div class="form-grid">
        <!-- RECIBE -->
        <div class="form-field form-field--wide">
          <label>
            ¿QUIÉN RECIBE?
          </label>
          <mat-form-field class="address-input" appearance="outline">
            <input matInput formControlName="receiving_name" maxlength="64" autocomplete="name" placeholder="Nombre de quien recibe">
          </mat-form-field>
          <mat-error *ngIf="receivingName?.invalid && (receivingName?.dirty || receivingName?.touched)">
            {{ getErrorMessage('receiving_name') }}
          </mat-error>
        </div>
        <!-- CALLE -->
        <div class="form-field">
          <label>
            CALLE
          </label>
          <mat-form-field class="address-input" appearance="outline">
            <input matInput formControlName="street" maxlength="128" autocomplete="street-address" placeholder="Nombre de la calle">
          </mat-form-field>
          <mat-error *ngIf="street?.invalid && (street?.dirty || street?.touched)">
            {{ getErrorMessage('street') }}
          </mat-error>
        </div>
        <!-- NUMERO -->
        <div class="form-field">
          <label>
            NÚMERO EXTERIOR
          </label>
          <mat-form-field class="address-input" appearance="outline">
            <input matInput formControlName="ext_number" maxlength="10" placeholder="Número exterior">
          </mat-form-field>
          <mat-error *ngIf="extNumber?.invalid && (extNumber?.dirty || extNumber?.touched)">
            {{ getErrorMessage('ext_number') }}
          </mat-error>
        </div>
        <!-- CP -->
        <div class="form-field">
          <label>
            CÓDIGO POSTAL
          </label>
          <mat-form-field class="address-input" appearance="outline">
            <input matInput formControlName="zip_code" maxlength="5" inputmode="numeric" placeholder="Código postal" (input)="searchDataZipCode()">
          </mat-form-field>
          <mat-error *ngIf="zipCode?.invalid && (zipCode?.dirty || zipCode?.touched)">
            {{ getErrorMessage('zip_code') }}
          </mat-error>
        </div>
        <!-- COLONIA -->
        <div class="form-field">
          <label>
            COLONIA
          </label>
          <mat-form-field class="address-input" appearance="outline">
            <mat-select formControlName="locality_id" placeholder="Selecciona una colonia"
              (selectionChange)="onSelectionLocality($event.value)">
              <mat-option *ngFor="let locality of localities" [value]="locality.id">
                {{ locality.name }}
              </mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error *ngIf="localityId?.invalid && (localityId?.dirty || localityId?.touched)">
            {{ getErrorMessage('locality_id') }}
          </mat-error>
        </div>
        <!-- MUNICIPIO -->
        <div class="form-field">
          <label>
            MUNICIPIO
          </label>
          <mat-form-field class="address-input" appearance="outline">
            <input matInput formControlName="municipality" readonly placeholder="Municipio">
          </mat-form-field>
        </div>
        <!-- ESTADO -->
        <div class="form-field">
          <label>
            ESTADO
          </label>
          <mat-form-field class="address-input" appearance="outline">
            <input matInput formControlName="state" readonly placeholder="Estado">
          </mat-form-field>
        </div>
        <!-- TELEFONO -->
        <div class="form-field">
          <label>
            TELÉFONO
          </label>
          <mat-form-field class="address-input" appearance="outline">
            <input matInput formControlName="phone" maxlength="10" inputmode="tel" autocomplete="tel"
              placeholder="Teléfono">
          </mat-form-field>
          <mat-error *ngIf="phone?.invalid &&
                        (phone?.dirty || phone?.touched)">
            {{ getErrorMessage('phone') }}
          </mat-error>
        </div>
        <!-- REFERENCIAS -->
        <div class="form-field form-field--wide">
          <label>
            REFERENCIAS
          </label>
          <mat-form-field class="address-input address-textarea" appearance="outline">
            <textarea matInput formControlName="references" maxlength="128" rows="2"
              placeholder="Ej. casa con portón negro, frente al parque...">
            </textarea>
          </mat-form-field>
          <mat-error *ngIf="references?.invalid && (references?.dirty || references?.touched)">
            {{ getErrorMessage('references') }}
          </mat-error>
        </div>
      </div>
      <!-- =================================================
                 MAPA
                 ================================================= -->
      <section class="map-section" *ngIf="!complementAddress">
        <div class="map-section-header">
          <div>
            <span class="map-eyebrow">
              UBICACIÓN
            </span>
            <h3>
              Ubicación en el mapa
            </h3>
            <p>
              Da clic o arrastra el pin hasta la ubicación exacta.
            </p>
          </div>
          <div class="map-section-icon">
            <mat-icon>
              location_on
            </mat-icon>
          </div>
        </div>
        <div class="map-container">
          <agm-map [latitude]="mapLatitude" [longitude]="mapLongitude" [zoom]="zoom" (mapClick)="onMapClickEvent($event)">
            <!-- UBICACIÓN DE REFERENCIA -->
            <agm-marker *ngIf="hasReferenceLocation" [latitude]="referenceLatitude" [longitude]="referenceLongitude">
              <agm-info-window [isOpen]="true">
                <div class="map-info-window">
                  <strong>
                    Ubicación de referencia
                  </strong>
                  <div class="map-info-address">
                    {{ referenceAddress || 'Ubicación de referencia' }}
                  </div>
                </div>
              </agm-info-window>
            </agm-marker>
            <!-- UBICACIÓN SELECCIONADA -->
            <agm-marker *ngIf="hasLocation" [latitude]="latitude" [longitude]="longitude" [markerDraggable]="true"
              (dragEnd)="markerDragEnd($event)">
              <agm-info-window [isOpen]="true">
                <div class="map-info-window">
                  <strong>
                    Ubicación seleccionada
                  </strong>
                  <div class="map-info-address">
                    {{ hasSelectedLocation
                    ? 'Ubicación seleccionada por ti'
                    : 'Esta es la ubicación de referencia' }}
                  </div>
                </div>
              </agm-info-window>
            </agm-marker>
          </agm-map>
        </div>
        <p class="map-address" *ngIf="addressFromMap">
          {{ addressFromMap }}
        </p>
        <mat-error class="map-error" *ngIf="(lat?.invalid || lng?.invalid) &&
                    (lat?.touched || lng?.touched)">
          Marca la ubicación de tu dirección en el mapa.
        </mat-error>
      </section>
      <!-- =================================================
                 ACCIONES
                 ================================================= -->
      <div class="new-address-actions">
        <button class="cancel-button" mat-button type="button" (click)="close()">
          Cancelar
        </button>
        <button class="save-address-button" mat-raised-button type="submit" [disabled]="isSaving">
          Guardar dirección
        </button>
      </div>
    </form>
  </div>
</mat-dialog-content>